import React from 'react';
import ReactDOM from 'react-dom';
import { NavLink } from 'react-router-dom';
import { getProjects, resolveImageUrl } from '../../services/api';

const galleryCategories = ["All", "ACP Front Elevation", "Facade Glazing", "Toughened Glass"];

const defaultProjects = [
    {
        id: "proj-1",
        slug: "acp-front-elevation-five-star",
        mainImage: require('./../../images/products/acp_cladding.jpg'),
        title: 'ACP Front Elevation - Five Star Towers',
        location: 'Trichy Road, Singanallur, Coimbatore',
        category: 'ACP Front Elevation'
    },
    {
        id: "proj-2",
        slug: "facade-glazing-showroom",
        mainImage: require('./../../images/products/facade_glazing.jpg'),
        title: 'Facade Glazing & Showroom Elevation',
        location: 'Trichy Road, Coimbatore',
        category: 'Facade Glazing'
    },
    {
        id: "proj-3",
        slug: "toughened-glass-atrium-complex",
        mainImage: require('./../../images/products/structural_glazing.jpg'),
        title: 'Toughened Glass Partitions & Structural Atrium',
        location: 'Avinashi Road, Coimbatore',
        category: 'Toughened Glass'
    },
    {
        id: "proj-4",
        slug: "singanallur-luxury-residence-front-elevation",
        mainImage: require('./../../images/products/front_elevation.jpg'),
        title: 'Singanallur Villa Front Elevation',
        location: 'Singanallur, Coimbatore',
        category: 'ACP Front Elevation'
    }
];

class Projects extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            projects: defaultProjects,
            activeFilter: 'All',
            selectedProject: null
        };
    }

    async componentDidMount() {
        try {
            const apiProjects = await getProjects({}, defaultProjects);
            if (apiProjects && Array.isArray(apiProjects) && apiProjects.length > 0) {
                this.setState({ projects: apiProjects });
            }
        } catch (e) {
            console.warn('[Projects] API fetch fallback to default projects.');
        }

        window.addEventListener('keydown', this.handleKeyDown);
    }

    componentWillUnmount() {
        window.removeEventListener('keydown', this.handleKeyDown);
        if (typeof document !== 'undefined') {
            document.body.style.overflow = '';
        }
    }

    resolveImageUrl = (img) => {
        if (!img) return defaultProjects[0].mainImage;
        if (typeof img === 'string') {
            if (img.startsWith('http://') || img.startsWith('https://') || img.startsWith('data:')) return img;
            return resolveImageUrl(img);
        }
        return img;
    };

    handleKeyDown = (e) => {
        if (e.key === 'Escape' && this.state.selectedProject) {
            this.closeLightbox();
        }
    };

    handleFilterClick = (filterKey) => {
        this.setState({ activeFilter: filterKey });
    };

    openLightbox = (item, imgSrc) => {
        this.setState({
            selectedProject: {
                ...item,
                imgSrc: imgSrc
            }
        });
        if (typeof document !== 'undefined') {
            document.body.style.overflow = 'hidden';
        }
    };

    closeLightbox = () => {
        this.setState({ selectedProject: null });
        if (typeof document !== 'undefined') {
            document.body.style.overflow = '';
        }
    };

    sanitizeCategory = (cat = '') => {
        if (cat.toLowerCase().includes('acp')) return 'ACP Front Elevation';
        if (cat.toLowerCase().includes('facade')) return 'Facade Glazing';
        if (cat.toLowerCase().includes('toughened')) return 'Toughened Glass';
        return cat;
    };

    render() {
        const { projects, activeFilter, selectedProject } = this.state;

        const cleanedProjects = projects.map(p => ({
            ...p,
            category: this.sanitizeCategory(p.category || '')
        }));

        let displayProjects = [];

        if (activeFilter === 'All') {
            const seenCats = new Set();
            for (const p of cleanedProjects) {
                const cat = p.category;
                if (!seenCats.has(cat) && displayProjects.length < 3) {
                    seenCats.add(cat);
                    displayProjects.push(p);
                }
            }
            if (displayProjects.length < 3) {
                for (const p of cleanedProjects) {
                    if (displayProjects.length < 3 && !displayProjects.some(dp => dp.id === p.id)) {
                        displayProjects.push(p);
                    }
                }
            }
        } else {
            const matches = cleanedProjects.filter(item => {
                const itemCat = (item.category || '').toLowerCase();
                const targetCat = activeFilter.toLowerCase();
                return itemCat.includes(targetCat) || targetCat.includes(itemCat);
            });
            displayProjects = matches.slice(0, 1);
        }

        return (
            <>
                <style>{`
                    .projects-section-wrap {
                        background-color: #ffffff !important;
                    }
                    .projects-grid-container {
                        display: flex;
                        flex-wrap: wrap;
                        justify-content: center;
                        margin-left: -12px;
                        margin-right: -12px;
                    }
                    .project-card-item {
                        width: 33.333%;
                        max-width: 33.333%;
                        flex: 0 0 33.333%;
                        padding: 0 12px;
                        margin-bottom: 24px;
                        box-sizing: border-box;
                    }
                    @media (max-width: 991px) {
                        .project-card-item {
                            width: 50%;
                            max-width: 50%;
                            flex: 0 0 50%;
                        }
                    }
                    @media (max-width: 767px) {
                        .project-card-item {
                            width: 100% !important;
                            max-width: 100% !important;
                            flex: 0 0 100% !important;
                            padding: 0 8px;
                            margin-bottom: 18px;
                        }
                        .filter-navigation-btns button {
                            padding: 7px 16px !important;
                            font-size: 12.5px !important;
                        }
                    }
                `}</style>
                <div className="section-full mobile-page-padding p-t80 p-b50 projects-section-wrap">
                    <div className="container">
                        <div className="section-head text-center m-b40">
                            <div className="sx-separator-outer separator-center">
                                <div className="sx-separator bg-white">
                                    <h3 className="sep-line-one">Projects</h3>
                                </div>
                            </div>
                        </div>

                        {/* CENTERED CATEGORY FILTER BUTTONS */}
                        <div className="filter-navigation text-center" style={{ marginBottom: '35px', display: 'flex', justifyContent: 'center' }}>
                            <div className="filter-pills-container">
                                {galleryCategories.map((cat, idx) => (
                                    <button
                                        key={idx}
                                        onClick={() => this.handleFilterClick(cat)}
                                        className={`filter-btn ${activeFilter === cat ? 'active' : ''}`}
                                        style={{
                                            border: activeFilter === cat ? 'none' : '1px solid #ddd',
                                            backgroundColor: activeFilter === cat ? '#f03a02' : '#f8f9fa',
                                            color: activeFilter === cat ? '#ffffff' : '#333333',
                                            boxShadow: activeFilter === cat ? '0 4px 14px rgba(240, 58, 2, 0.35)' : 'none'
                                        }}
                                    >
                                        {cat}
                                    </button>
                                ))}
                            </div>
                        </div>

                        {/* PROJECTS GRID - RESPONSIVE 1 COL ON MOBILE, 2 ON TAB, 3 ON DESKTOP */}
                        <div className="projects-grid-container">
                            {displayProjects.map((item, index) => {
                                const imgSrc = this.resolveImageUrl(item.mainImage || item.image);

                                return (
                                    <div className="project-card-item" key={item.id || index}>
                                        <div 
                                            onClick={() => this.openLightbox(item, imgSrc)}
                                            style={{
                                                borderRadius: '16px',
                                                overflow: 'hidden',
                                                backgroundColor: '#ffffff',
                                                boxShadow: '0 8px 24px rgba(0,0,0,0.08)',
                                                border: '1px solid #eeeeee',
                                                transition: 'transform 0.35s ease, box-shadow 0.35s ease',
                                                cursor: 'pointer',
                                                height: '270px',
                                                position: 'relative'
                                            }}
                                            onMouseEnter={(e) => {
                                                e.currentTarget.style.transform = 'translateY(-6px)';
                                                e.currentTarget.style.boxShadow = '0 16px 32px rgba(0,0,0,0.15)';
                                            }}
                                            onMouseLeave={(e) => {
                                                e.currentTarget.style.transform = 'translateY(0)';
                                                e.currentTarget.style.boxShadow = '0 8px 24px rgba(0,0,0,0.08)';
                                            }}
                                        >
                                            <img 
                                                src={imgSrc} 
                                                alt="Project" 
                                                onError={(e) => { e.target.onerror = null; e.target.src = defaultProjects[0].mainImage; }}
                                                style={{ width: '100%', height: '100%', objectFit: 'cover' }} 
                                            />
                                        </div>
                                    </div>
                                );
                            })}
                        </div>

                        <div className="text-center m-t30">
                            <NavLink to="/projects" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} className="site-button" style={{ backgroundColor: '#f03a02', color: '#ffffff', border: 'none', borderRadius: '6px' }}>
                                <span>View Full Projects Gallery</span>
                            </NavLink>
                        </div>
                    </div>
                </div>

                {/* LIGHTBOX MODAL PREVIEW - PORTAL DIRECTLY ON DOCUMENT.BODY */}
                {selectedProject && typeof document !== 'undefined' && ReactDOM.createPortal(
                    <div onClick={this.closeLightbox} style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        width: '100vw',
                        height: '100dvh',
                        minHeight: '100%',
                        backgroundColor: 'rgba(0,0,0,0.85)',
                        zIndex: 9999999,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        padding: '16px',
                        boxSizing: 'border-box'
                    }}>
                        <div onClick={(e) => e.stopPropagation()} style={{
                            backgroundColor: '#ffffff',
                            borderRadius: '16px',
                            maxWidth: '750px',
                            width: '100%',
                            overflow: 'hidden',
                            position: 'relative',
                            boxShadow: '0 20px 50px rgba(0,0,0,0.5)',
                            textAlign: 'center',
                            margin: 'auto'
                        }}>
                            <button 
                                onClick={this.closeLightbox}
                                style={{
                                    position: 'absolute',
                                    top: '12px',
                                    right: '12px',
                                    background: '#111111',
                                    color: '#ffffff',
                                    border: 'none',
                                    borderRadius: '50%',
                                    width: '36px',
                                    height: '36px',
                                    fontSize: '18px',
                                    cursor: 'pointer',
                                    zIndex: 10
                                }}
                            >
                                &times;
                            </button>
                            <img 
                                src={selectedProject.imgSrc} 
                                alt="Project Full View" 
                                onError={(e) => { e.target.onerror = null; e.target.src = defaultProjects[0].mainImage; }}
                                style={{ width: '100%', maxHeight: '80dvh', objectFit: 'contain', backgroundColor: '#111' }} 
                            />
                        </div>
                    </div>,
                    document.body
                )}
            </>
        );
    }
}

export default Projects;
